<div class="login-info mt-auto">
  <h1>Welcome to <span>Path Coordination System</span></h1>
  <p class="login-info-text">Login to access your account.</p>
</div>

<div class="login-info-footer mt-auto">
  <ul class="list-inline">
    <li class="list-inline-item">
      PCS EC: {{version}}, {{releaseDate}}
    </li>
    <li class="list-inline-item">
      PCS Web Services: {{wsVersion}}
    </li>
  </ul>
</div>


